const ProfileType = {
  PLC: "plc",
  PLB: "plb",
  PT: "pt",
  BOS: "bos",
  HOS: "hos",
};

export default ProfileType;
